// extracted by mini-css-extract-plugin
export default {"statistics":"city-statistics_statistics__Zkpj+","statistics_left":"city-statistics_statistics_left__o6mfo","statistics_right":"city-statistics_statistics_right__cPUoO"};